import React, { useEffect, useState, useRef } from 'react';
import { Button } from '../components/ui/Button';
import { Icon } from '@iconify/react';
// Mock data
const initialValutatori = [{
  id: 1,
  nome: 'Roberto',
  cognome: 'Sergio',
  email: 'roberto.sergio@rai.it',
  stato: false,
  settoriCompetenza: 3,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 2,
  nome: 'Mario',
  cognome: 'Lavezzi',
  email: 'mario.lavezzi@gmail.com',
  stato: false,
  settoriCompetenza: 1,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 3,
  nome: 'Giancarlo',
  cognome: 'De Cataldo',
  email: 'ildandi@gmail.com',
  stato: false,
  settoriCompetenza: 3,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 4,
  nome: 'Sara',
  cognome: 'Chiappori',
  email: 'sarachiappori@gmail.com',
  stato: false,
  settoriCompetenza: 1,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 5,
  nome: 'Anna',
  cognome: 'Cremonini',
  email: 'anna@annacremonini.it',
  stato: false,
  settoriCompetenza: 2,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 6,
  nome: 'Valerio',
  cognome: 'Toniolo',
  email: 'valeriotoniolo74@gmail.com',
  stato: false,
  settoriCompetenza: 2,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 7,
  nome: 'Rita',
  cognome: 'Borioni',
  email: 'ritaborioni@alice.it',
  stato: false,
  settoriCompetenza: 2,
  settoriAssegnati: 2,
  assegnate: 3,
  valutate: 4
}, {
  id: 8,
  nome: 'Test',
  cognome: 'Valutatore',
  email: 'testvalutatore@siae.it',
  stato: true,
  settoriCompetenza: 0,
  settoriAssegnati: 5,
  assegnate: 16,
  valutate: 2
}, {
  id: 9,
  nome: 'Valutatore',
  cognome: 'uno',
  email: 'valutatore1@siae.it',
  stato: true,
  settoriCompetenza: 0,
  settoriAssegnati: 3,
  assegnate: 12,
  valutate: 10
}, {
  id: 10,
  nome: 'Valutatore',
  cognome: 'due',
  email: 'valutatore2@siae.it',
  stato: true,
  settoriCompetenza: 0,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 11,
  nome: 'Valutatore',
  cognome: 'tre',
  email: 'valutatore3@siae.it',
  stato: true,
  settoriCompetenza: 0,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}, {
  id: 12,
  nome: 'Valutatore',
  cognome: 'quattro',
  email: 'valutatore4@siae.it',
  stato: true,
  settoriCompetenza: 0,
  settoriAssegnati: 0,
  assegnate: 0,
  valutate: 0
}];
const settoriOptions = ['Arti visive, performative e multimediali', 'Cinema', 'Danza', 'Libro e lettura', 'Musica', 'Teatro'];
interface TabView {
  id: string;
  name: string;
  filters: {
    nome: string;
    cognome: string;
    email: string;
    stato: string;
    settori: string;
  };
  searchQuery: string;
  rowsPerPage: number;
  currentPage: number;
}
const createDefaultTab = (id: string, name: string): TabView => ({
  id,
  name,
  filters: {
    nome: '',
    cognome: '',
    email: '',
    stato: 'TUTTI',
    settori: ''
  },
  searchQuery: '',
  rowsPerPage: 10,
  currentPage: 1
});
export function GestioneValutatori() {
  const [valutatori, setValutatori] = useState(initialValutatori);
  // Tab System State
  const [tabs, setTabs] = useState<TabView[]>([createDefaultTab('tab-1', 'Tutti')]);
  const [activeTabId, setActiveTabId] = useState<string>('tab-1');
  const [editingTabId, setEditingTabId] = useState<string | null>(null);
  const [editTabName, setEditTabName] = useState('');
  const editInputRef = useRef<HTMLInputElement>(null);
  const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];
  const updateActiveTab = (updates: Partial<TabView>) => {
    setTabs(prev => prev.map(tab => tab.id === activeTabId ? {
      ...tab,
      ...updates
    } : tab));
  };
  const handleAddTab = () => {
    const newId = `tab-${Date.now()}`;
    const newName = `Vista ${tabs.length + 1}`;
    const newTab = createDefaultTab(newId, newName);
    setTabs([...tabs, newTab]);
    setActiveTabId(newId);
  };
  const handleRemoveTab = (e: React.MouseEvent, idToRemove: string) => {
    e.stopPropagation();
    if (tabs.length <= 1) return;
    const newTabs = tabs.filter(t => t.id !== idToRemove);
    setTabs(newTabs);
    if (activeTabId === idToRemove) {
      setActiveTabId(newTabs[newTabs.length - 1].id);
    }
  };
  const handleDoubleClickTab = (tab: TabView) => {
    setEditingTabId(tab.id);
    setEditTabName(tab.name);
  };
  const handleSaveTabName = () => {
    if (editingTabId && editTabName.trim()) {
      setTabs(prev => prev.map(tab => tab.id === editingTabId ? {
        ...tab,
        name: editTabName.trim()
      } : tab));
    }
    setEditingTabId(null);
  };
  const handleKeyDownTabName = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveTabName();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };
  useEffect(() => {
    if (editingTabId && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [editingTabId]);
  // Modal state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [selectedValutatore, setSelectedValutatore] = useState<number | null>(null);
  const [newEvaluator, setNewEvaluator] = useState({
    nome: '',
    cognome: '',
    email: '',
    password: '',
    settori: [] as string[]
  });
  const {
    filters,
    searchQuery,
    rowsPerPage,
    currentPage
  } = activeTab;
  // Filter logic
  const filteredData = valutatori.filter(item => {
    const matchesSearch = item.nome.toLowerCase().includes(searchQuery.toLowerCase()) || item.cognome.toLowerCase().includes(searchQuery.toLowerCase()) || item.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = item.nome.toLowerCase().includes(filters.nome.toLowerCase()) && item.cognome.toLowerCase().includes(filters.cognome.toLowerCase()) && item.email.toLowerCase().includes(filters.email.toLowerCase()) && (filters.stato === 'TUTTI' || filters.stato === 'ATTIVO' && item.stato || filters.stato === 'NON ATTIVO' && !item.stato);
    return matchesSearch && matchesFilters;
  });
  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage) || 1;
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const currentData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    updateActiveTab({
      filters: {
        ...filters,
        [key]: value
      },
      currentPage: 1
    });
  };
  const handleStatusToggle = (id: number) => {
    setSelectedValutatore(id);
    setIsConfirmDialogOpen(true);
  };
  const confirmStatusChange = () => {
    if (selectedValutatore !== null) {
      setValutatori(prev => prev.map(v => v.id === selectedValutatore ? {
        ...v,
        stato: !v.stato
      } : v));
      setIsConfirmDialogOpen(false);
      setSelectedValutatore(null);
    }
  };
  const handleAddEvaluator = () => {
    const newId = Math.max(...valutatori.map(v => v.id)) + 1;
    const evaluator = {
      id: newId,
      nome: newEvaluator.nome,
      cognome: newEvaluator.cognome,
      email: newEvaluator.email,
      stato: true,
      settoriCompetenza: newEvaluator.settori.length,
      settoriAssegnati: 0,
      assegnate: 0,
      valutate: 0
    };
    setValutatori([evaluator, ...valutatori]);
    setIsAddModalOpen(false);
    setNewEvaluator({
      nome: '',
      cognome: '',
      email: '',
      password: '',
      settori: []
    });
  };
  const toggleSector = (sector: string) => {
    setNewEvaluator(prev => {
      const exists = prev.settori.includes(sector);
      return {
        ...prev,
        settori: exists ? prev.settori.filter(s => s !== sector) : [...prev.settori, sector]
      };
    });
  };
  return <div className="space-y-6" data-id="element-1369">
      {/* Header */}
      <div className="bg-white p-6 flex justify-between items-center" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px'
    }} data-id="element-1370">
        <h1 className="text-2xl text-navy-primary font-normal font-roboto" data-id="element-1371">
          Gestione Valutatori - {activeTab.name}
        </h1>
        <Button variant="primary" onClick={() => setIsAddModalOpen(true)} className="flex items-center gap-2" data-id="element-1372">
          <Icon icon="tabler:plus" fontSize={16} data-id="element-1373" />
          Aggiungi valutatore
        </Button>
      </div>

      {/* Tab Bar Workspace */}
      <div className="bg-white flex items-center overflow-x-auto" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '0 32px'
    }} data-id="element-1374">
        <div className="flex items-end gap-2 pt-2" data-id="element-1375">
          {tabs.map(tab => {
          const isActive = tab.id === activeTabId;
          const isEditing = tab.id === editingTabId;
          return <div key={tab.id} onClick={() => setActiveTabId(tab.id)} onDoubleClick={() => handleDoubleClickTab(tab)} className="group flex items-center gap-2 relative transition-colors" style={{
            padding: '14px 16px',
            paddingBottom: '12px',
            cursor: 'pointer',
            color: isActive ? '#293B54' : '#80858E',
            borderBottom: isActive ? '2px solid #2A97DF' : '2px solid transparent',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '15px',
            fontWeight: isActive ? 500 : 400,
            marginBottom: '-1px'
          }} data-id="element-1376">
                {isEditing ? <input ref={editInputRef} type="text" value={editTabName} onChange={e => setEditTabName(e.target.value)} onBlur={handleSaveTabName} onKeyDown={handleKeyDownTabName} style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '15px',
              fontWeight: 500,
              color: '#293B54',
              border: 'none',
              outline: 'none',
              background: 'transparent',
              width: `${Math.max(editTabName.length * 9, 60)}px`,
              padding: 0
            }} data-id="element-1377" /> : <span className="select-none whitespace-nowrap" data-id="element-1378">
                    {tab.name}
                  </span>}

                {tabs.length > 1 && !isEditing && <button onClick={e => handleRemoveTab(e, tab.id)} className={`flex items-center justify-center rounded-full p-0.5 transition-colors ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} style={{
              color: '#AAAAAA',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => e.currentTarget.style.color = '#EA5455'} onMouseLeave={e => e.currentTarget.style.color = '#AAAAAA'} aria-label="Chiudi vista" data-id="element-1379">
                    <Icon icon="tabler:x" fontSize={14} data-id="element-1380" />
                  </button>}
              </div>;
        })}

          <button onClick={handleAddTab} className="flex items-center gap-1 transition-colors mb-2 ml-2" style={{
          padding: '8px 12px',
          color: '#AAAAAA',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '4px'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F5F5F5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-1381">
            <Icon icon="tabler:plus" fontSize={14} data-id="element-1382" />
            Nuova vista
          </button>
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white" style={{
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      overflow: 'hidden'
    }} data-id="element-1383">
        {/* Toolbar */}
        <div className="p-4 border-b border-gray-200 flex items-center gap-4" data-id="element-1384">
          <div className="relative w-[300px]" data-id="element-1385">
            <Icon icon="tabler:search" fontSize={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1386" />
            <input type="text" placeholder="Cerca valutatori..." value={searchQuery} onChange={e => updateActiveTab({
            searchQuery: e.target.value
          })} className="w-full h-9 pl-9 pr-3 border border-gray-200 text-sm font-roboto focus:outline-none focus:border-navy-primary" data-id="element-1387" />
          </div>
          <button className="h-9 w-9 flex items-center justify-center border border-gray-200 text-gray-500 hover:bg-gray-50" data-id="element-1388">
            <Icon icon="tabler:columns" fontSize={16} data-id="element-1389" />
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-1390">
          <table className="w-full min-w-[1000px] border-collapse" data-id="element-1391">
            <thead data-id="element-1392">
              <tr className="border-b border-gray-200" data-id="element-1393">
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[150px]" data-id="element-1394">
                  Nome
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[150px]" data-id="element-1395">
                  Cognome
                </th>
                <th className="text-left p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[200px]" data-id="element-1396">
                  Email
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[120px]" data-id="element-1397">
                  Stato
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[160px]" data-id="element-1398">
                  Settori
                  <br data-id="element-1399" />
                  Competenza
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[160px]" data-id="element-1400">
                  Settori Assegnati
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[120px]" data-id="element-1401">
                  Assegnate
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[120px]" data-id="element-1402">
                  Valutate
                </th>
                <th className="text-center p-4 text-xs font-medium text-navy-primary uppercase tracking-wider w-[120px]" data-id="element-1403">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1404">
              <tr className="bg-white" data-id="element-1405">
                <td className="p-2 pl-4" data-id="element-1406">
                  <input type="text" placeholder="Filtra name..." value={filters.nome} onChange={e => handleFilterChange('nome', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs" data-id="element-1407" />
                </td>
                <td className="p-2" data-id="element-1408">
                  <input type="text" placeholder="Filtra surname..." value={filters.cognome} onChange={e => handleFilterChange('cognome', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs" data-id="element-1409" />
                </td>
                <td className="p-2" data-id="element-1410">
                  <input type="text" placeholder="Filtra email..." value={filters.email} onChange={e => handleFilterChange('email', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs" data-id="element-1411" />
                </td>
                <td className="p-2" data-id="element-1412">
                  <select value={filters.stato} onChange={e => handleFilterChange('stato', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs bg-white" data-id="element-1413">
                    <option value="TUTTI" data-id="element-1414">TUTTI</option>
                    <option value="ATTIVO" data-id="element-1415">ATTIVO</option>
                    <option value="NON ATTIVO" data-id="element-1416">NON ATTIVO</option>
                  </select>
                </td>
                <td className="p-2" data-id="element-1417">
                  <input type="text" placeholder="Filtra settori..." value={filters.settori} onChange={e => handleFilterChange('settori', e.target.value)} className="w-full h-8 px-2 border border-gray-200 text-xs" data-id="element-1418" />
                </td>
                <td colSpan={4} data-id="element-1419"></td>
              </tr>

              {/* Data Rows */}
              {currentData.map(row => <tr key={row.id} className="border-b border-gray-100 hover:bg-blue-50 transition-colors" data-id="element-1420">
                  <td className="p-4 text-sm text-gray-700 font-roboto" data-id="element-1421">
                    {row.nome}
                  </td>
                  <td className="p-4 text-sm text-gray-700 font-roboto" data-id="element-1422">
                    {row.cognome}
                  </td>
                  <td className="p-4 text-sm text-gray-700 font-roboto" data-id="element-1423">
                    {row.email}
                  </td>
                  <td className="p-4 text-center" data-id="element-1424">
                    <button onClick={() => handleStatusToggle(row.id)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${row.stato ? 'bg-navy-primary' : 'bg-gray-200'}`} data-id="element-1425">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${row.stato ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1426" />
                    </button>
                  </td>
                  <td className="p-4 text-center text-sm text-gray-700 font-roboto" data-id="element-1427">
                    {row.settoriCompetenza}
                  </td>
                  <td className="p-4 text-center text-sm text-gray-700 font-roboto" data-id="element-1428">
                    {row.settoriAssegnati}
                  </td>
                  <td className="p-4 text-center text-sm text-gray-700 font-roboto" data-id="element-1429">
                    {row.assegnate}
                  </td>
                  <td className="p-4 text-center text-sm text-gray-700 font-roboto" data-id="element-1430">
                    {row.valutate}
                  </td>
                  <td className="p-4 text-center" data-id="element-1431">
                    <button className="p-1.5 text-gray-400 hover:text-navy-primary hover:bg-gray-100 rounded transition-colors" data-id="element-1432">
                      <Icon icon="tabler:eye" fontSize={18} data-id="element-1433" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex items-center justify-end gap-4 text-sm text-gray-600" data-id="element-1434">
          <div className="flex items-center gap-2" data-id="element-1435">
            <span data-id="element-1436">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => updateActiveTab({
            rowsPerPage: Number(e.target.value),
            currentPage: 1
          })} className="border-none bg-transparent font-medium focus:outline-none cursor-pointer" data-id="element-1437">
              <option value={10} data-id="element-1438">10</option>
              <option value={25} data-id="element-1439">25</option>
              <option value={50} data-id="element-1440">50</option>
            </select>
          </div>
          <span data-id="element-1441">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div className="flex items-center gap-1" data-id="element-1442">
            <button onClick={() => updateActiveTab({
            currentPage: Math.max(1, currentPage - 1)
          })} disabled={currentPage === 1} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1443">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1444" />
            </button>
            <button onClick={() => updateActiveTab({
            currentPage: Math.min(totalPages, currentPage + 1)
          })} disabled={currentPage === totalPages || totalItems === 0} className="p-1 hover:bg-gray-100 rounded disabled:opacity-50" data-id="element-1445">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1446" />
            </button>
          </div>
        </div>
      </div>

      {/* Add Evaluator Modal */}
      {isAddModalOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1447">
          <div className="bg-white w-[600px] shadow-xl" data-id="element-1448">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center" data-id="element-1449">
              <h2 className="text-xl font-roboto text-navy-primary" data-id="element-1450">
                Aggiungi Valutatore
              </h2>
              <button onClick={() => setIsAddModalOpen(false)} className="text-gray-400 hover:text-gray-600" data-id="element-1451">
                <Icon icon="tabler:x" fontSize={24} data-id="element-1452" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-1453">
              <div className="grid grid-cols-2 gap-4" data-id="element-1454">
                <div data-id="element-1455">
                  <label className="block text-sm text-gray-600 mb-1" data-id="element-1456">
                    Nome
                  </label>
                  <input type="text" value={newEvaluator.nome} onChange={e => setNewEvaluator({
                ...newEvaluator,
                nome: e.target.value
              })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary" data-id="element-1457" />
                </div>
                <div data-id="element-1458">
                  <label className="block text-sm text-gray-600 mb-1" data-id="element-1459">
                    Cognome
                  </label>
                  <input type="text" value={newEvaluator.cognome} onChange={e => setNewEvaluator({
                ...newEvaluator,
                cognome: e.target.value
              })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary" data-id="element-1460" />
                </div>
              </div>
              <div data-id="element-1461">
                <label className="block text-sm text-gray-600 mb-1" data-id="element-1462">
                  Email
                </label>
                <input type="email" value={newEvaluator.email} onChange={e => setNewEvaluator({
              ...newEvaluator,
              email: e.target.value
            })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary" data-id="element-1463" />
              </div>
              <div data-id="element-1464">
                <label className="block text-sm text-gray-600 mb-1" data-id="element-1465">
                  Password
                </label>
                <input type="password" value={newEvaluator.password} onChange={e => setNewEvaluator({
              ...newEvaluator,
              password: e.target.value
            })} className="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:border-navy-primary" data-id="element-1466" />
              </div>
              <div data-id="element-1467">
                <label className="block text-sm text-gray-600 mb-2" data-id="element-1468">
                  Settori di competenza
                </label>
                <div className="space-y-2 max-h-[200px] overflow-y-auto border border-gray-300 rounded p-3" data-id="element-1469">
                  {settoriOptions.map(sector => <label key={sector} className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 rounded" data-id="element-1470">
                      <div className={`w-4 h-4 border rounded flex items-center justify-center ${newEvaluator.settori.includes(sector) ? 'bg-navy-primary border-navy-primary' : 'border-gray-300'}`} onClick={e => {
                  e.preventDefault();
                  toggleSector(sector);
                }} data-id="element-1471">
                        {newEvaluator.settori.includes(sector) && <Icon icon="tabler:check" fontSize={12} className="text-white" data-id="element-1472" />}
                      </div>
                      <span className="text-sm text-gray-700" data-id="element-1473">{sector}</span>
                    </label>)}
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3" data-id="element-1474">
              <Button variant="outlined" onClick={() => setIsAddModalOpen(false)} data-id="element-1475">
                Annulla
              </Button>
              <Button variant="primary" onClick={handleAddEvaluator} data-id="element-1476">
                Salva
              </Button>
            </div>
          </div>
        </div>}

      {/* Confirmation Dialog */}
      {isConfirmDialogOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1477">
          <div className="bg-white w-[400px] shadow-xl p-6" data-id="element-1478">
            <h3 className="text-lg font-medium text-navy-primary mb-4" data-id="element-1479">
              Conferma azione
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1480">
              Sei sicuro di voler modificare lo stato di questo valutatore?
            </p>
            <div className="flex justify-end gap-3" data-id="element-1481">
              <Button variant="outlined" onClick={() => setIsConfirmDialogOpen(false)} data-id="element-1482">
                Annulla
              </Button>
              <Button variant="primary" onClick={confirmStatusChange} data-id="element-1483">
                Conferma
              </Button>
            </div>
          </div>
        </div>}
    </div>;
}